import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {DataService} from '../services/dataService';
import {DocumentType, MediaType, RouleauDoc as Doc, Media} from '../../common';
import {ActivatedRoute, Router} from '@angular/router';
import {PageEnum} from '../entity';

@Component({
    selector   : 'app-doc',
    templateUrl: './doc.component.html',
    styleUrls  : ['./doc.component.scss']
})
export class DocComponent implements OnInit {
    /**
     * Liste des media.
     */
    private media: Array<Media> = [];
    /**
     * Liste des docs.
     */
    private _docs: Array<Doc> = [];
    /**
     * Doc Code
     */
    private docCode: string = 'ROOT';
    /**
     * Current Doc
     */
    private _currentDoc: Doc = null;
    /**
     * Current Media
     */
    private _currentMedia: Media = null;
    /**
     * Sub Doc
     */
    private _subDocs: Array<Doc> = [];
    /**
     * Is Doc Show
     */
    private _isDocShow: boolean = false;
    /**
     * Is Not Found Show
     */
    private _isNotFoundShow: boolean = false;
    /**
     * Have a previous
     */
    private _havePrevious: boolean = false;
    /**
     * Enum Export
     */
    private _mediaType = MediaType;
    /**
     * Enum Export
     */
    private _DocumentType = DocumentType;

    /**
     * Constructor
     * @param translate
     * @param dataService
     * @param route
     * @param router
     */
    constructor(protected translate: TranslateService,
                protected dataService: DataService,
                private route: ActivatedRoute,
                private router: Router) {
    }


    /**
     * NgOnInit
     */
    public ngOnInit() {
        console.log('OnInit DocComponent');
        this.dataService.cleanNewPage();
        this.translate.get('docPage.pageTitle').subscribe(
            (res: string) => {
                this.dataService.publishNewPageTitle(PageEnum.DOC, res);
            }
        );
        this.route.params.subscribe(params => {
            // console.log('+++ route.queryParams', params);
            this.docCode = params['docCode'];
            if (this.docCode == null || this.docCode === '') {
                this.docCode = 'ROOT';
            }
            this.initData();
        });
    }

    /**
     * Init Data.
     */
    private initData(): void {
        const p1 = this.dataService.getDocs().then(
            (docs) => {
                // docs.length = 20;
                this._docs = docs;
                console.log('------------------- DOCS');
                console.log(this._docs);
                console.log('------------------- /DOCS');
            },
            () => {
                // cas erreur
                // TODO Gérer le cas d'erreur.
            }
        );
        const p2 = this.dataService.getMedia().then(
            (media) => {
                this.media = media;
            },
            () => {
                // cas erreur
                // TODO Gérer le cas d'erreur.
            }
        );
        Promise.all([p1, p2]).then(
            () => {
                this.initDoc();
            },
            () => {
                // cas erreur
                // TODO Gérer le cas d'erreur.
            }
        );
    }

    /**
     * Init Doc.
     */
    private initDoc(): void {
        let doc = this._docs.find(value => value.codeRouleau === this.docCode);
        if (doc == null) {
            if (this.docCode === 'ROOT') {
                doc = new Doc();
                doc.codeRouleau = 'ROOT';
                doc.nom = '';
                doc.type = DocumentType.MENU;
                doc.codeMedia = '';
                doc.codeParent = '';
                doc.rang = 1;

                this._currentDoc = doc;
                this.findCurrentMedia();
                this._subDocs = this._docs.filter(
                    value => value.codeParent == null || value.codeParent === ''
                ).sort((a, b) => a.rang - b.rang);
                if (this._subDocs.length > 0) {
                    this._havePrevious = false;
                    this._isDocShow = true;
                    this._isNotFoundShow = false;
                } else {
                    this._havePrevious = false;
                    this._isDocShow = true;
                    this._isNotFoundShow = true;
                }
            } else {
                this._havePrevious = false;
                this._isDocShow = false;
                this._isNotFoundShow = true;
            }
        } else {
            this._currentDoc = doc;
            this.findCurrentMedia();
            this._subDocs = this._docs.filter(
                value => value.codeParent === this.docCode
            ).sort((a, b) => a.rang - b.rang);
            this._havePrevious = this._currentDoc.codeRouleau !== 'ROOT';
            this._isDocShow = true;
            this._isNotFoundShow = false;
        }
    }

    /**
     * Find the current Media.
     */
    private findCurrentMedia(): void {
        this._currentMedia = this.media.find(
            value => value.code === this._currentDoc.codeMedia
        );
        console.log(this.media);
        console.log(this._currentMedia);
    }


    /**
     * Choose the doc.
     * @param doc
     */
    public chooseDoc(doc: Doc): void {
        this.router.navigate(['/doc', doc.codeRouleau], {replaceUrl: true}).catch(() => {
        });
    }

    /**
     * Go the parent.
     */
    public goPrevious(): void {
        if (this.currentDoc.codeParent != null && this.currentDoc.codeParent !== '') {
            this.router.navigate(['/doc', this.currentDoc.codeParent], {replaceUrl: true}).catch(() => {
            });
        } else {
            this.router.navigate(['/doc'], {replaceUrl: true}).catch(() => {
            });
        }
    }

    /**
     * Get the thunmbnail Media Path
     * @param doc document
     */
    public getThumbnailMediaPath(doc: Doc): string {
        const medium = this.media.find(
            value => value.code === doc.codeMedia
        );
        let res: string = null;
        if (medium != null) {
            res = medium.thumbnailPath;
        }
        console.log('getThumbnailMediaPath', doc, res);
        return res;
    }

    /**
     * Get the thunmbnail Media Path
     * @param doc document
     */
    public getMediaPath(doc: Doc): string {
        const medium = this.media.find(
            value => value.code === doc.codeMedia
        );
        let res: string = null;
        if (medium != null) {
            res = medium.filePath;
        }
        return res;
    }


    /**
     * Get the thunmbnail Media Path
     */
    public getCurrentMediaPath(): string {
        let res: string = null;
        if (this._currentMedia != null) {
            res = this._currentMedia.filePath;
        }
        console.log('------------------- PATH');
        console.log(res);
        console.log('------------------- /PATH');
        return res;
    }


    /**
     * Getter.
     */
    public get currentDoc(): Doc {
        return this._currentDoc;
    }

    /**
     * Getter.
     */
    public get currentMedia(): Media {
        return this._currentMedia;
    }

    /**
     * Getter.
     */
    public get subDocs(): Array<Doc> {
        return this._subDocs;
    }

    /**
     * Getter.
     */
    public get isDocShow(): boolean {
        return this._isDocShow;
    }

    /**
     * Getter.
     */
    public get havePrevious(): boolean {
        return this._havePrevious;
    }

    /**
     * Getter.
     */
    public get isNotFoundShow(): boolean {
        return this._isNotFoundShow;
    }

    /**
     * Getter
     */
    public get mediaType() {
        return this._mediaType;
    }

    /**
     * Getter.
     */
    public get DocumentType() {
        return this._DocumentType;
    }
}
